import { render } from "./SettingsMenu.vue?vue&type=template&id=75a5a517&scoped=true"
import script from "./SettingsMenu.vue?vue&type=script&lang=js"
export * from "./SettingsMenu.vue?vue&type=script&lang=js"

import "./SettingsMenu.vue?vue&type=style&index=0&id=75a5a517&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a5a517"]])

export default __exports__